
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perks/[perkId]",
      function () {
        return require("private-next-pages/perks/[perkId]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perks/[perkId]"])
      });
    }
  